import { validDotPath } from '@assess/shared/dynamic-components';
import { logger } from '@assess/shared/logger';
import { Nullable } from '@assess/shared/type-utilities';

import { Control } from '../types/control.type';

export const getControl = (control: Nullable<Control>, path: string): Control | undefined => {
  if (!control) {
    logger.warn({ context: 'getControl', data: { path } }, 'Invalid control');

    return;
  }

  if (!path || !validDotPath.test(path)) {
    logger.warn({ context: 'getControl', data: { path } }, 'Invalid path');

    return;
  }

  const [first, ...rest] = path.split('.');

  if (rest.length === 0) {
    return control?.controls?.[first];
  }

  return rest.reduce(
    (current: any, part: string) => {
      return current?.controls && Object.prototype.hasOwnProperty.call(current?.controls, part)
        ? current.controls[part]
        : undefined;
    },
    control?.controls?.[first]
  );
};
